import { OfferEvolutionInsightsV2 } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

export const evolutionInsightsState = atom<OfferEvolutionInsightsV2 | null>(
  null
);
